import React, { useState, useCallback } from 'react';

export default function Password({ authenticate, embedded = false }) {
  const [value, setValue] = useState('');
  const [hasAttempted, setHasAttempted] = useState(false);
  const [isValid, setIsValid] = useState(true);

  const handleChange = useCallback((event) => {
    setValue(event.target.value);
    if (hasAttempted && !isValid) {
      setIsValid(true);
    }
  }, [hasAttempted, isValid]);

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    const expectedPassword = process.env.REACT_APP_ROUTE_KEY;
    if (!expectedPassword) {
      console.error('REACT_APP_ROUTE_KEY is not configured');
      setIsValid(false);
      setHasAttempted(true);
      return;
    }
    if (value.trim() === expectedPassword) {
      authenticate();
    } else {
      setIsValid(false);
      setHasAttempted(true);
    }
  }, [value, authenticate]);

  const formContent = (
    <>
      <label className="password-label" htmlFor="route-password">
        Enter password to continue
      </label>
      <input
        type="password"
        value={value}
        onChange={handleChange}
        className={`password-input ${hasAttempted && !isValid ? 'password-input--error' : ''}`}
        id="route-password"
        placeholder="**********"
        autoComplete="off"
        required
        aria-invalid={hasAttempted && !isValid}
        aria-describedby={hasAttempted && !isValid ? 'password-error' : undefined}
        autoFocus
      />
      {hasAttempted && !isValid && (
        <p id="password-error" className="password-error" role="alert">
          Please enter a valid password.
        </p>
      )}
      <button type="submit" className="btn btn-primary password-submit">
        Unlock
      </button>
      <a href="/" className="password-back">Go back to home</a>
    </>
  );

  if (embedded) {
    return (
      <form
        onSubmit={handleSubmit}
        className="password-form password-form--embedded"
        aria-labelledby="password-gate-title"
      >
        <h2 id="password-gate-title" className="password-form__title">Guest area</h2>
        {formContent}
      </form>
    );
  }

  return (
    <div className="password-page">
      <form onSubmit={handleSubmit} className="password-form">
        <h1 className="section-title">Guest area</h1>
        {formContent}
      </form>
    </div>
  );
}
